import { render } from "./UpayHeroku.vue?vue&type=template&id=aba1eccc&scoped=true"
import script from "./UpayHeroku.vue?vue&type=script&lang=js"
export * from "./UpayHeroku.vue?vue&type=script&lang=js"

import "./UpayHeroku.vue?vue&type=style&index=0&id=aba1eccc&scoped=true&lang=css"

import exportComponent from "/tmp/build_2d2f4584/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba1eccc"]])

export default __exports__